<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <div class="_title">
          <v-icon small>
            mdi-magnify
          </v-icon>
          SQL Viewer
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.ssr') }}</v-card-title>
          <div class="box">
            <table class="section" width="100%">
              <thead>
                <tr>
                  <th width="14%" class="text-left">{{ this.$t('sql.system') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.userId') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.begin') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.end') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.respti') }}</th>
                  <th width="14%" class="text-left">{{ this.$t('sql.db.time') }}</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-text-field :value="step.sid" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.acc" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="format(step.sdt, 'yyyy-MM-dd HH:mm:ss')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="format(step.edt, 'yyyy-MM-dd HH:mm:ss')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.rt | comma | concat(' ms')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.dbt | comma | concat(' ms')" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td></td>
                </tr>
              </tbody>
            </table>
            <table class="section" width="100%">
              <thead>
                <tr>
                  <th width="14%" class="text-left">{{ this.$t('sql.tcode') }}</th>
                  <th width="28%" class="text-left">{{ this.$t('sql.report') }}</th>
                  <th width="28%" class="text-left">{{ this.$t('sql.cua.prog') }}</th>
                  <th class="text-left">{{ this.$t('sql.cua.func') }}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><v-text-field :value="step.tcode" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.report" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.cuap" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                  <td><v-text-field :value="step.cuaf" class="text-full-width" outlined dense hide-details readonly></v-text-field></td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.sqlList') }}</v-card-title>
          <div class="box">
            <v-data-table v-model="selectedSqls" :headers="headers" :items="sqls" item-key="pcapTs" :loading="loading" @click:row="highlight" height="150" :items-per-page="-1" class="elevation-0 content" dense hide-default-footer single-select fixed-header>
              <template v-slot:item.svrYmdhms="{ value }">
                {{ format(value, 'yyyy-MM-dd HH:mm:ss') }}
              </template>
              <template v-slot:item.respti="{ value }">
                {{ Math.ceil(value / 1000) | comma | concat(' ms') }}
              </template>
              <template v-slot:footer>
                <v-textarea :value="selectedSql.command" class="text-full-width" height="80" outlined dense hide-details readonly></v-textarea>
              </template>
            </v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card class="card-wrap">
          <v-card-title>{{ this.$t('sql.title.param') }}</v-card-title>
          <div class="box">
            <v-data-table :headers="paramsHeaders" :items="selectedSql.paramList" item-key="seq" :loading="loading" height="280" :items-per-page="-1" class="elevation-0 content" dense hide-default-footer single-select fixed-header></v-data-table>
          </div>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { api } from '../../../api/common/instances';
import { format } from 'date-fns';

export default {
  data() {
    return {
      step: {
        sdt: parseInt(this.$route.query.sdt),
        edt: parseInt(this.$route.query.edt),
        sid: this.$route.query.sid,
        iid: this.$route.query.iid,
        wpid: this.$route.query.wpid,
        man: this.$route.query.man,
        acc: this.$route.query.acc,
        report: this.$route.query.report,
        tcode: this.$route.query.tcode,
        cuap: this.$route.query.cuap,
        cuaf: this.$route.query.cuaf,
        rt: parseInt(this.$route.query.rt),
        dbt: parseInt(this.$route.query.dbt),
      },
      sqls: [],
      // 테이블이 single-select 이더라도 veutify의 data-table의 v-model은
      // 무조건 array를 원하므로 어쩔 수 없어 array를 사용해야 함.
      selectedSqls: [],
      selectedSql: {},
      params: {},
      loading: false,
      itemsPerPage: -1,
    };
  },
  computed: {
    headers() {
      return [
        { text: this.$t('sql.begin'), value: 'svrYmdhms', sortable: false, width: '15%' },
        { text: this.$t('sql.sql.time'), value: 'respti', sortable: false, width: '15%' },
        { text: this.$t('sql.src.module'), value: 'srcModule', sortable: false },
        { text: this.$t('sql.line.number'), value: 'lineNumber | comma', sortable: false, width: '10%' },
      ];
    },
    paramsHeaders() {
      return [
        { text: this.$t('sql.param.seq'), value: 'seq', sortable: false, width: '10%' },
        { text: this.$t('sql.param.value'), value: 'value', sortable: false },
      ];
    },
  },
  async created() {
    this.loading = true;
    ({ data: this.sqls } = await api.get('/analysis/sqlviewer/hscn-list', {
      params: {
        srchBgnYmdhms: this.step.sdt,
        srchEndYmdhms: this.step.edt,
        sstmId: this.step.sid,
        instId: this.step.iid,
        wpid: this.step.wpid,
        mandt: this.step.man,
        account: this.step.acc,
      },
    }));
    if (this.sqls.length == 0) {
      this.loading = false;
      return;
    }
    // 최초 로딩 시에는 첫번째 행이 선택 되도록...
    this.selectedSql = this.sqls[0];
    this.selectedSql.isSelected = true;
    this.selectedSqls.push(this.selectedSql);
    this.loading = false;
  },
  watch: {
    selectedSqls(value) {
      this.selectedSql = value[0];
    },
  },
  methods: {
    highlight(item, { isSelected, select }) {
      // 같은 row를 클릭했을 때는 선택이 풀리지 않도록 리턴...
      if (item.pcapTs === this.selectedSql.pcapTs) {
        return;
      }
      select(!isSelected);
    },
    format,
  },
};
</script>

<style lang="scss" scoped>
.container {
  padding: 0 10px 10px 10px;
  margin: 0;
  max-width: 100%;
}
._title {
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.0125em;
  line-height: 2;
}
.section th {
  padding: 0 0 3px 6px;
}
.section td {
  padding: 0 0 0 3px;
}
.text-full-width {
  width: auto;
}
</style>
